const H = {
  name: "Malaysia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 6H4V22H10V17H14V22H20V6H18V2H16V6H14V15H10V6H8V2H6V6ZM16 17H18V20H16V17ZM18 15H16V13H18V15ZM16 11V8H18V11H16ZM8 11H6V8H8V11ZM6 15V13H8V15H6ZM6 17H8V20H6V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Malaysia
};
